import { Group } from '@unistocks/components/group/group';
import React from 'react';
import { ListItem, ListItemProps } from 'tamagui';

export const MenuItem: React.FC<ListItemProps> = ({ onPress, ...props }) => {
  return (
    <Group.Item>
      <ListItem
        cursor={onPress ? 'pointer' : undefined}
        gap={'$3'}
        scaleIcon={2}
        onPress={onPress}
        {...props}
      />
    </Group.Item>
  );
};

MenuItem.displayName = 'MenuItem';
